import dynamic from 'next/dynamic';
import { UserAddressProps } from './UserAddress.types';

export const UserAddress = dynamic<UserAddressProps>(() => import('./UserAddress').then(module => module.UserAddress));
